export default "__VITE_ASSET__Clp3ktfw__"